import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Category } from '../../services/client/model/category';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { APIService } from '../../services/client/api/api.service';
import { CategoryQuestionss } from '../../services/client/model/categoryQuestions';
import { Subscription } from 'rxjs';
import { AnswersRepositoryService } from '../../services/answers-repository.service';
import { RoutesManagerService } from '../../services/routes-manager.service';

@Component({
  selector: 'app-poll-manager',
  templateUrl: './poll-manager.component.html',
  styleUrls: ['./poll-manager.component.css']
})
export class PollManagerComponent implements OnInit, OnDestroy {

  index = 0;
  currentCategory: boolean[] = [];
  renderedQuestions: boolean;
  currentCategoryQuestions: CategoryQuestionss;
  progressValue = 0;
  categories: Category[];
  error = false;
  subscription: Subscription;
  subscriptionCategory: Subscription;

  constructor(private router: Router, private apiService: APIService, private answersRepository: AnswersRepositoryService, private routesManager: RoutesManagerService) {
    this.initialConfig();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionCategory) {
      this.subscriptionCategory.unsubscribe();
    }
  }

  ngOnInit(): void {
  }

  updateProgressBar() {
    this.progressValue = this.index * 10;
  }

  handleButtonClick(event: any) {
    if (event === 'next') {
      this.currentCategory[this.index] = false;
      this.index++;
      if ((this.categories[this.index]) !== undefined) {
        this.getCurrentCategoryQuestions();
        this.currentCategory[this.index] = true;
        this.updateProgressBar();
        window.scrollTo(0, 0);
      } else {
        this.answersRepository.categoryIndex = this.index - 1;
        this.routesManager.setLocalRouteValue('finalizacion');
        this.router.navigate(['finalizacion']);
      }
    }
    else {
      if (this.index === 0) {
        this.routesManager.setLocalRouteValue('datos');
        this.router.navigate(['datos']);
      }
      else {
        this.currentCategory[this.index] = false;
        this.index--;
        this.getCurrentCategoryQuestions();
        this.updateProgressBar();
        this.currentCategory[this.index] = true;
        window.scrollTo(0, 0);
      }
    }
  }

  initialConfig() {
    if (this.answersRepository.categoryIndex) {
      this.index = this.answersRepository.categoryIndex;
      this.updateProgressBar();
    }
    this.subscription = this.apiService.categoriesGet().subscribe(
      (data: Category[]) => {
        this.categories = data.filter(category => (data.indexOf(category) !== data.length - 1) && category);
        this.categories.forEach(() => this.currentCategory.push(false));
        this.currentCategory[this.index] = true;
        this.getCurrentCategoryQuestions();
      },
      () => {
        this.error = true;
      }
    );
  }

  getCurrentCategoryQuestions() {
    this.renderedQuestions = false;
    this.subscriptionCategory = this.apiService.categoryCategoryIdQuestionsGet(this.categories[this.index].id)
      .subscribe(
        currentQuestions => {
          this.currentCategoryQuestions = {
            category: this.categories[this.index],
            questions: currentQuestions
          };
          this.renderedQuestions = true;
        },
        () => {
          this.error = true;
          this.renderedQuestions = false;
        }
      );
  }

}
